import { Pipe, PipeTransform } from '@angular/core';
import { Const } from '../../../core/helpers/Const';

@Pipe({
    name: 'sortByFixed',
    standalone: false
})
export class SortByFixedPipe implements PipeTransform {
    transform<T>(tableRows: T[] | null | undefined, ascending: boolean, field: string): any[] {
        if (!field) {
            return tableRows;
        }
        return tableRows.sort((a: T, b: T) => {
            const resourceTypeOrder = Const.RESOURCE_TYPE_ORDER;
            let leftSideValue: any = a;
            let rightSideValue: any = b;

            leftSideValue = leftSideValue[field] || '';
            rightSideValue = rightSideValue[field] || '';

            if (resourceTypeOrder.indexOf(leftSideValue) > resourceTypeOrder.indexOf(rightSideValue)) {
                return ascending ? -1 : 1;
            } else if (resourceTypeOrder.indexOf(leftSideValue) < resourceTypeOrder.indexOf(rightSideValue)) {
                return ascending ? 1 : -1;
            }
            return 0;
        });
    }
}
